
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faStar, faUsers, faXmark } from '@fortawesome/free-solid-svg-icons'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { Link } from "react-router-dom"

function CopyCard({ trade_id, image, name, winrate, profit, win, loss, copy, price, info, pending }) {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [modalIsOpen2, setIsOpen2] = useState(false);
    const { user } = useUser();
    const [copied, setCopied] = useState(copy);
    const [pend, setPending] = useState(pending);
    const [loading, setLoading] = useState(false);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const ValidateCopy = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_copy: true, trade_id: trade_id, price: price, copied : !copied })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            if(copied == false){
              setPending(true);
              setCopied(!copied);
            }else{
              setCopied(!copied);
            }
          }else{
            toast.error(data.message);
            setLoading(false);
          }
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
          toast.error('There was an issue processing your deposit.')
        })
    }
    return (
      <div className="mycard p-3 mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-center rounded-2 overflow-hidden" style={{height:'40px',width:'40px'}}>
              {image}
            </div>
            <div className="ms-2">
              <p className="mb-0 fw-bold">{name}</p>
              <div className="d-flex align-items-center">
                <p className="mb-0 rounded-2 py-0 px-1 text-secondary fw-bold d-inline-block" style={{backgroundColor:'#ffffff0c', fontSize:'14px'}}>
                  <FontAwesomeIcon icon={faUsers} style={{fontSize: '14px'}} /> {info ? info.current_copiers : '100/500'}</p>
                <p className="mb-0 rounded-2 py-0 px-1 text-secondary fw-bold d-inline-block ms-1" style={{backgroundColor:'#ffffff0c', fontSize:'14px'}}>API</p>
              </div>
            </div>
          </div>
          <FontAwesomeIcon icon={faStar} style={{fontSize: '18px'}} className="text-warning" />
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div>
            <p className="mb-0 text-secondary lh-1" style={{fontSize:'14px'}}>Profit Share</p>
            <p className="mb-0 text-success fw-bold" style={{fontSize:'22px'}}>{profit}%</p>
            <p className="mb-0 text-secondary lh-1" style={{fontSize:'14px'}}>Win Rate <span className="text-success">{winrate}%</span></p>
          </div>
          <div style={{width:'40%'}}>
            <img src="uploads/chartline.png" alt="logo" className="mb-4" style={{width:'100%'}}/>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Copy Price</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>AUM (USDT)</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{info ? formatCurrency(info.aum) : '--'}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>No. Win</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{win ? win : '--'}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>No. Loss</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{loss ? loss : '--'}</p>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          {(pend && copied) ? (
            <div className={`myBtn text-center text-uppercase fw-bold bg-secondary w-100`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={() => setIsOpen(true)}>Pending</div>
          ) : (
            <>
              <Link to="/copyprofile" state={{trade_id : trade_id}} className={`myBtn bg-secondary text-center text-uppercase fw-bold`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px',width: '30%',}}>View</Link>
              <div className={`myBtn ${copied?'bg-danger':'bg-prime'} text-center text-uppercase fw-bold`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px',width: '67%',}} onClick={() => {copied ? setIsOpen2(true) : setIsOpen1(true) }}>{copied?'Copied':'Copy'}</div>
            </>
          )}
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white text-prime text-center w-100 text-uppercase" style={{fontSize: '14px'}}>Information</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <p className="text-center fw-bold mx-lg-5 mt-3" style={{fontSize:'20px'}}>Your request to copy this trade is currently under approval.</p>
          <div className={`myBtn text-center text-uppercase fw-bold bg-prime w-100 mt-3`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={() => setIsOpen(false)}>OK</div>
        </Modal>
        <Modal
          isOpen={modalIsOpen1}
          onRequestClose={() => setIsOpen1(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white text-prime text-center w-100 text-uppercase" style={{fontSize: '14px'}}>Copy Trade</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
          </div>
          <p className="fw-bold mt-3 mb-0" style={{fontSize:'20px'}}>Copy Trader - {name}</p>
          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>You are about to copy the above trader at a price of <span className="fw-bold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</span></p>
          <div className={`myBtn bg-success text-center text-uppercase w-100 fw-bold mt-3`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={ValidateCopy}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Copy'}</div>
        </Modal>
        <Modal
          isOpen={modalIsOpen2}
          onRequestClose={() => setIsOpen2(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white text-prime text-center w-100 text-uppercase" style={{fontSize: '14px'}}>Uncopy Trade</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
          </div>
          <p className="fw-bold mt-3 mb-0" style={{fontSize:'20px'}}>Copy Trader - {name}</p>
          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>You are currently copying this trader at a price of <span className="fw-bold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</span>. If you wish to stop copying, click "Uncopy" below. </p>
          <div className={`myBtn bg-danger text-center text-uppercase w-100 fw-bold mt-3`} style={{paddingTop: '8px',paddingBottom: '8px', fontSize:'12px'}} onClick={ValidateCopy}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Uncopy'}</div>
        </Modal>
      </div>
    )
  }
  
  export default CopyCard